import React from 'react';
import TemplateParametro from '../shared/templateParametros/templateParametros';
import OperadorParametroFaixaBancariaClusterService from '../../../../lib/api/operadorParametroFaixaBancariaCluster/operadorParametroFaixaBancariaClusterService';

class OperadorParametroFaixaBancariaCluster extends React.Component<{},{}> 
{
    constructor(props: any)
    {
        super(props);
        this.state = {};
    }

    baixarExcelCluster()
    {
        return OperadorParametroFaixaBancariaClusterService.obterExcel();
    }

    enviarParametrosEventGrid()
    {
        return OperadorParametroFaixaBancariaClusterService.enviarParametrosAoEventGrid();
    }

    render()
    {
        return (
            <TemplateParametro
                enviarParametrosEventGrid={this.enviarParametrosEventGrid}
                baixarExcelParametros={this.baixarExcelCluster}
                enviarExcelParametros={OperadorParametroFaixaBancariaClusterService.salvarExcelParametros}
                deletarExcelParametros={OperadorParametroFaixaBancariaClusterService.deletarExcelParametros}
                nomeDoArquivo='Operador Parâmetro Faixa Bancária Cluster'
            ></TemplateParametro>
        );
    }
}

export default OperadorParametroFaixaBancariaCluster;